// /src/i18n.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import translations from './locales';

i18n
  .use(initReactI18next)
  .init({
    resources: translations,
    lng: 'en',  // langue par défaut
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
